<template>
  <section class="hero">
    
    <div class="container-fluid d-none d-sm-block" style="height: 510px;
  background: url('/assets/img/climate-finance-composition46.jpg') top / cover no-repeat;">
        <div class="row" style="height: 500px;">
         <div class="col-md-4 col-xl-5 offset-xl-0">
        <div class="text-hover-wrap">
        <router-link class="pb-0 d-xl-flex justify-content-xl-center me-0"
        to="/climate"
        style="font-family:'Nortune', sans-serif;font-weight:700;font-size:50px;text-align:center;">
          <span style="color:rgb(27, 53, 73);">CLIMATE</span></router-link>
          <router-link class="pb-0 d-xl-flex justify-content-xl-center me-0"
          to="/climate"
          style="font-family:'Nortune', sans-serif;font-weight:700;font-size:50px;text-align:center;">
          <span class="d-xl-flex justify-content-xl-center align-items-xl-start"
          style="color: #3F85A6;font-size: 50px;font-family:
          'Raleway', sans-serif;margin-top: -20px;">Finance Faculty</span>
          </router-link>
          </div>
                <hr style="height: 250px;background: rgba(255,255,255,0);"><a class="pb-0 d-xl-flex justify-content-xl-center me-0" href="{{ route('climate_home') }}" style="font-family:'Nortune', sans-serif;font-weight:700;font-size:50px;text-align:center;"><span class="d-xl-flex justify-content-xl-center align-items-xl-start" style="color: #3F85A6;font-size: 50px;font-family: 'Raleway', sans-serif;margin-top: -20px;"></span></a><a href="#" style="margin-bottom: 20px;">
                  <h2 class="text-center" style="margin-bottom: -30px;font-family: 'Nortune', sans-serif;font-weight:700;color: #FCEE05;font-size: 40px;">Click</h2><br>
                    <h5 class="text-center" style="margin: 0px;padding-top: -10px;color: #FCEE05;font-size: 30px;font-weight: normal;">On Any Choice Around</h5>
                </a>
            </div>
            <div class="text-center col-md-4 col-xl-3 offset-xl-0 d-xl-flex justify-content-xl-center align-items-xl-end"><a href="{{ route('gap_departments') }}" style="margin-bottom: 15px;">
                    <h2 class="text-center" style="margin-bottom: -30px;font-family: 'Nortune', sans-serif;font-weight:700;color: white;font-size: 50px;"> GAP </h2><br>
                    <h5 class="text-center" style="margin: 0px;padding-top: -20px;color: white;font-size: 40px;font-weight: normal;">Faculties </h5>
                </a>
              </div>
            <div class="text-center col-md-4 col-xl-3 offset-xl-0 d-xl-flex justify-content-xl-center align-items-xl-end"><a href="https://gapmanagementinstitute.org/" style="margin-bottom: 20px;">
                    <h5 class="text-center" style="margin: 0px;padding-top: -10px;color: white;font-size: 15px;font-weight: normal;">Visit www.gapmanagementinstitute.org</h5>
                </a></div>
        </div>
</div>
<!--    three column row -->

        <div class="px-0 container-fluid home-navigation-tiles d-none d-sm-block" style="background-color: #971836;">
          <div class="text-center row g-0" style="padding-left: 25px; padding-right: 25px;">
            <div class="mb-3 col-md-4 tile-card">
              <img src="/assets/img/GapResources.jpg" alt="GAP Resources" class="tile-image" />
            </div>
            <div class="mb-3 col-md-4 tile-card">
              <img src="/assets/img/CMSTOOLS13.jpg" alt="CMS Apps" class="tile-image" />

            </div>
            <div class="mb-3 col-md-4 tile-card">
              <img src="/assets/img/Exploremore3.jpg" alt="Explore More" class="tile-image" />
            </div>
          </div>
        </div>

  </section>
</template>

<script>
import { apiFetch, API_BASE_URL } from '../api/client'
export default {
  name: 'HomePage',
  data() {
    return { apiMessage: 'Checking…' }
  },
  async mounted() {
    // Apply body class to enable tile backgrounds from style.css
    document.body.classList.add('gap-home')
    try {
      const res = await apiFetch('/api/ping')
      const json = await res.json()
      this.apiMessage = `${json.message} @ ${json.timestamp} (${API_BASE_URL || 'same-origin'})`
    } catch (e) {
      this.apiMessage = `Error: ${e.message}`
    }
  },
  beforeUnmount() {
    document.body.classList.remove('gap-home')
  }
}
</script>

<style scoped>
/* Allow the page to grow so the footer stays at the bottom */
.hero { width: 100%; height: auto; }
.hero-img { width: 100%; height: 100%; object-fit: cover; display: block; }

/* Remove default anchor underline (router-link renders as <a>) */
.hero a,
.hero a:hover,
.hero a:focus,
.hero a:active,
.hero a:visited {
  text-decoration: none !important;
}

.hero a:focus {
  outline: none;
}

/* Pop-out hover card behind the two hero links */
.text-hover-wrap {
  position: relative;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}

.text-hover-wrap::before {
  content: '';
  position: absolute;
  inset: -12px -18px;
  background: rgba(255, 255, 255, 0.482);
  border-radius: 16px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.28);
  opacity: 0;
  transform: translateY(8px) scale(0.98);
  transition: opacity 0.2s ease, transform 0.2s ease;
  pointer-events: none;
}

.text-hover-wrap:hover::before,
.text-hover-wrap:focus-within::before {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.text-hover-wrap > a {
  position: relative;
  z-index: 1;
}

.text-hover-wrap a {
  transition: transform 0.2s ease, filter 0.2s ease;
  will-change: transform;
}

.text-hover-wrap a span {
  display: inline-block;
  transition: transform 0.2s ease, text-shadow 0.2s ease;
  will-change: transform;
}

.text-hover-wrap:hover a,
.text-hover-wrap:focus-within a {
  transform: translateY(-3px);
}

.text-hover-wrap:hover a span,
.text-hover-wrap:focus-within a span {
  transform: scale(1.02);
  text-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);
}

.tile-image {
  width: auto;
  max-width: 100%;
  object-fit: contain;
  object-position: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.tile-card { position: relative; }
.tile-card:hover .tile-image {
  transform: translateY(-6px) scale(1.04);
  box-shadow: 0 14px 28px rgba(0,0,0,0.22), 0 10px 10px rgba(0,0,0,0.12);
  z-index: 2;
}
</style>
